/**
 * The Day / Night / Auto control for the grocery customer surface.
 * One 44px button, an icon AND a word (never colour alone), cycling
 * Auto -> Day -> Night. It lives in the header row, away from the floating
 * chef button and the points chip.
 */
import { useTranslation } from 'react-i18next';
import { Moon, Sun, SunMoon } from 'lucide-react';
import { useGroceryMode } from '../../lib/groceryTheme';

const ICON = { auto: SunMoon, day: Sun, night: Moon };

export default function GroceryModeToggle({ memberKey, testId = 'grocery-mode-toggle',
    compact = false }) {
    const { t } = useTranslation();
    const { mode, cycle } = useGroceryMode(memberKey);
    const Icon = ICON[mode] || SunMoon;
    const label = t(`grocery.mode.${mode}`);
    return (
        <button onClick={cycle} data-testid={testId} data-mode={mode}
            aria-label={`${t('grocery.mode.label')}: ${label}`} title={t('grocery.mode.label')}
            className={`flex min-h-[44px] items-center gap-2 rounded-full border-2 border-slate-200 px-3 font-semibold text-foreground transition-colors hover:border-[#F58220] dark:border-slate-700 ${compact ? 'text-xs' : 'text-sm'}`}>
            <Icon className="h-4 w-4 shrink-0 text-[#F58220]" />
            <span data-testid={`${testId}-label`}>{label}</span>
        </button>
    );
}
